export type ViewerRandomSelection = {
  modelPath?: string;
  vaseId?: number;
  posterSrc?: string;
  posterAlt?: string;
  colourCombinationId?: string;
};

export function normalizeHexColor(value: string) {
  const trimmed = value.trim();
  const shortMatch = /^#([0-9a-f]{3})$/i.exec(trimmed);
  if (shortMatch) {
    const [r, g, b] = shortMatch[1].split('');
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return /^#([0-9a-f]{6})$/i.test(trimmed) ? trimmed : null;
}

export function isAtmosphericGlowColor(value: string) {
  const normalized = normalizeHexColor(value);
  if (!normalized) return false;
  const red = Number.parseInt(normalized.slice(1, 3), 16) / 255;
  const green = Number.parseInt(normalized.slice(3, 5), 16) / 255;
  const blue = Number.parseInt(normalized.slice(5, 7), 16) / 255;
  const luminance = red * 0.2126 + green * 0.7152 + blue * 0.0722;
  return luminance > 0.08;
}

export function mergeViewerPipelineOverrides(
  base: Record<string, unknown> | undefined,
  override?: Record<string, unknown> | undefined,
  ...moreOverrides: (Record<string, unknown> | undefined)[]
) {
  let merged = mergeViewerPipelineOverridesPair(base, override);
  for (const next of moreOverrides) {
    merged = mergeViewerPipelineOverridesPair(merged, next);
  }
  return merged;
}

function mergeViewerPipelineOverridesPair(
  base: Record<string, unknown> | undefined,
  override: Record<string, unknown> | undefined
) {
  if (!base && !override) return undefined;
  if (!override) return base;
  if (!base) return override;
  const baseLighting =
    base.lighting && typeof base.lighting === 'object' && !Array.isArray(base.lighting)
      ? (base.lighting as Record<string, unknown>)
      : undefined;
  const overrideLighting =
    override.lighting && typeof override.lighting === 'object' && !Array.isArray(override.lighting)
      ? (override.lighting as Record<string, unknown>)
      : undefined;
  return {
    ...base,
    ...override,
    ...(baseLighting || overrideLighting
      ? {
          lighting: {
            ...(baseLighting ?? {}),
            ...(overrideLighting ?? {}),
          },
        }
      : {}),
  };
}
